function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48",
  height: "30",
  viewBox: "0 0 48 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.531 18.95H6.635l-4.947-8.571 4.947-8.571h9.896l4.947 8.57-4.947 8.572zm-9.026-1.507h8.155l4.08-7.064-4.08-7.065H7.506L3.426 10.38l4.08 7.064z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.045 26.764h-9.893l-4.95-8.568 4.95-8.571h9.896l4.947 8.57-4.95 8.569zm-9.026-1.507h8.156l4.079-7.064-4.076-7.062h-8.159l-4.076 7.065 4.076 7.061z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.84 12.94a2.56 2.56 0 100-5.122 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.308 20.757a2.56 2.56 0 100-5.121 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.84 28.572a2.56 2.56 0 100-5.122 2.56 2.56 0 000 5.122z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.61 28.572a2.56 2.56 0 100-5.122 2.56 2.56 0 000 5.122z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.154 12.94a2.56 2.56 0 100-5.122 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.591 20.79a2.56 2.56 0 100-5.121 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.353 20.79a2.56 2.56 0 100-5.121 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.07 5.121a2.56 2.56 0 100-5.121 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.353 5.121a2.56 2.56 0 100-5.121 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.56 12.94a2.56 2.56 0 100-5.122 2.56 2.56 0 000 5.121z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "34.998",
  cy: "17.857",
  r: "12.143",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.06 21.667c.963 0 1.635-.297 2.112-.754.467-.446.73-1.051.768-1.676h-1.382c-.087.744-.671 1.25-1.498 1.25-1.168 0-1.907-1.042-1.907-2.49 0-1.41.613-2.5 1.897-2.5.817 0 1.343.466 1.47 1.18h1.4c-.145-1.35-1.157-2.391-2.87-2.391-2.053 0-3.338 1.607-3.338 3.71 0 2.134 1.392 3.671 3.348 3.671z",
  fill: "#FEA857"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.712 21.667c.963 0 1.635-.297 2.111-.754.468-.446.73-1.051.77-1.676H37.21c-.087.744-.671 1.25-1.498 1.25-1.168 0-1.907-1.042-1.907-2.49 0-1.41.613-2.5 1.897-2.5.818 0 1.343.466 1.47 1.18h1.4c-.145-1.35-1.157-2.391-2.87-2.391-2.053 0-3.337 1.607-3.337 3.71 0 2.134 1.391 3.671 3.347 3.671z",
  fill: "#FEA857"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.014 21.677c1.566 0 2.705-.803 2.705-2.242 0-1.528-1.168-1.875-2.598-2.193-1.032-.228-1.518-.396-1.518-.972 0-.506.496-.833 1.255-.833.72 0 1.265.357 1.343 1.071h1.352c-.107-1.428-1.119-2.212-2.685-2.212-1.547 0-2.667.724-2.667 2.123 0 1.478 1.139 1.816 2.385 2.103 1.06.248 1.722.387 1.722 1.082 0 .655-.633.912-1.353.912-.992 0-1.47-.337-1.566-1.19h-1.382c.048 1.498 1.119 2.351 3.007 2.351z",
  fill: "#FEA857"
})));